/**
 * ヒーローセクションのスライドショー制御（自動スライドのみ）
 * 
 * 機能:
 * - 自動スライド（5秒間隔）
 * - prefers-reduced-motion対応
 */

(function() {
    'use strict';

    // DOMContentLoadedイベントで実行
    document.addEventListener('DOMContentLoaded', function() {
        const slideshow = document.querySelector('.hero-slideshow');
        if (!slideshow) return;

        const slides = slideshow.querySelectorAll('.slide');
        if (slides.length === 0) return;

        let currentSlide = 0;
        let autoSlideInterval = null;

        // prefers-reduced-motionの確認
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        // 自動スライドの間隔（ミリ秒）
        const AUTO_SLIDE_INTERVAL = prefersReducedMotion ? 0 : 5000; // アニメーション無効時は自動スライドも無効

        /**
         * スライドを切り替える
         * @param {number} index - 表示するスライドのインデックス
         */
        function goToSlide(index) {
            if (index < 0 || index >= slides.length) return;

            // 現在のスライドからactiveクラスを削除
            slides[currentSlide].classList.remove('active');
            slides[currentSlide].setAttribute('aria-hidden', 'true');
            const currentImg = slides[currentSlide].querySelector('img');
            if (currentImg) {
                currentImg.setAttribute('aria-hidden', 'true');
            }

            // 新しいスライドにactiveクラスを追加
            currentSlide = index;
            slides[currentSlide].classList.add('active');
            slides[currentSlide].setAttribute('aria-hidden', 'false');
            const newImg = slides[currentSlide].querySelector('img');
            if (newImg) {
                newImg.setAttribute('aria-hidden', 'false');
            }
        }

        /**
         * 次のスライドに進む
         */
        function nextSlide() {
            const nextIndex = (currentSlide + 1) % slides.length;
            goToSlide(nextIndex);
        }

        /**
         * 自動スライドを開始
         */
        function startAutoSlide() {
            if (AUTO_SLIDE_INTERVAL === 0) return; // アニメーション無効時は自動スライドも無効

            stopAutoSlide();
            autoSlideInterval = setInterval(function() {
                nextSlide();
            }, AUTO_SLIDE_INTERVAL);
        }

        /**
         * 自動スライドを停止
         */
        function stopAutoSlide() {
            if (autoSlideInterval) {
                clearInterval(autoSlideInterval);
                autoSlideInterval = null;
            }
        }

        // 初期化: ARIA属性を設定
        slides.forEach((slide, index) => {
            const img = slide.querySelector('img');
            if (img) {
                if (index === currentSlide) {
                    slide.setAttribute('aria-hidden', 'false');
                    img.setAttribute('aria-hidden', 'false');
                } else {
                    slide.setAttribute('aria-hidden', 'true');
                    img.setAttribute('aria-hidden', 'true');
                }
            }
        });

        // 自動スライドを開始
        startAutoSlide();

        // ページが非表示になったら自動スライドを停止（パフォーマンス向上）
        document.addEventListener('visibilitychange', function() {
            if (document.hidden) {
                stopAutoSlide();
            } else {
                startAutoSlide();
            }
        });
    });
})();
